import { ActionButton } from '../../ActionButton/index';
import { PaymentMethodProps } from './types';
import { StyledPaymentMethod } from './style';

export const PaymentMethod: React.FC<PaymentMethodProps> = ({
  buttonText,
  checkoutWithCard,
  buttonColor,
  className,
  icon,
}) => (
  <StyledPaymentMethod
    className={className}
    colorOne={buttonColor.colorOne}
    colorTwo={buttonColor.colorTwo || buttonColor.colorOne}
    gradientDirection={buttonColor.gradientDirection}
  >
    <ActionButton
      action={checkoutWithCard}
      text={buttonText}
      colors={{
        colorOne: 'black',
      }}
      textColor="white"
      icon={icon}
    />
  </StyledPaymentMethod>
);
